/* eslint-disable no-use-before-define */
import React from 'react'
import { Disclosures, yieldGridLastUpdated } from '../../twd'

export default () => {
    let s = yieldGridLastUpdated()
    return <div className="row">
    <div className="col-xs-12 col-md-8">
    {s ? s + ' \u00A0 | \u00A0 ': ''}
    Yields update as prices change, and may be delayed.  Please see disclosures.
    </div>
    <div className="col-xs-12 col-md-4 text-right">
        <Disclosures
            dataName='municipals-yield-grid-disclosures-link'
            html={DISCLOSURES}
        />
    </div>
    </div>
}

let DISCLOSURES = `
    <p>
    The Yield by Category table can be sorted by highest or average yield.
    By default, the table is configured to display the highest available yield on
    the Tradeweb dealer network aligned with each municipal bond category (general obligation or revenue)
    and maturity.
    Offerings within each municipal bond category are further organized by
    investment grade or high yield credit quality.
    Split-rated offerings with an investment grade rating from one agency
    and high yield rating from the other will be categorized as high yield within the grid.
    To view the average yield amongst available offers for a given municipal bond category and maturity,
    simply click the "Average Yield" toggle above the table.
    </p>
    <p>
    The yield values displayed represent the existence of a minimum of 10 bonds ($1,000 face value)
    available at the respective credit ratings (as designated by Moody's or S&P) for which the ask price
    is between 85 and 120, excluding zero-coupon bonds (US Treasury Zeroes).
    </p>
    <p>
    Yields displayed within the grid will update in response to changes in available offerings and offering prices.
    These yields will update as offer pricing changes throughout the trading day and may be delayed.
    </p>`
